import { constantRoutes } from '@/router'
import { RouteRecordRaw } from 'vue-router'
import { MutationTree } from 'vuex'
import { PermissionMutationType } from './mutation-types'
import { PermissionInfo, PermissionState } from './state'

export type Mutations<S = PermissionState> = {
  [PermissionMutationType.SET_ROUTES](state: S, routes: RouteRecordRaw[]): void
  [PermissionMutationType.SET_PERMISSIONS](state: S, detail: PermissionInfo): void
}

export const mutations: MutationTree<PermissionState> & Mutations = {
  [PermissionMutationType.SET_ROUTES](state: PermissionState, routes: RouteRecordRaw[]) {
    state.routes = constantRoutes.concat(routes)
    state.dynamicRoutes = routes
  },

  [PermissionMutationType.SET_PERMISSIONS](state: PermissionState, detail: PermissionInfo) {
    state.permissionsInfo = detail
  }
}
